<template>
  <v-app id="cidadaos-duplicados" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Procedimento"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :search="search"
          item-key="index"
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal :data="data_esus_pec" />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastrosVuetfy',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    data_secretaria_de_saude: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    texto_esus_pec: {
      type: String,
      default: '',
    },
    data_esus_pec: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      enabled: null,
      search: '',
      headers: [
        {
          text: 'PROCEDIMENTO',
          align: 'start',
          filterable: true,
          sortable: false,
          value: 'procedimento',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cbo',
        },
        {
          text: 'IDADE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'idade',
        },
        {
          text: 'QUANTIDADE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quantidade',
        },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },
    getPagination(options) {
      this.currentPage = options.page
    },
  },
}
</script>

<style lang="scss"></style>
